import React from "react";
import { Input, type InputProps } from "semantic-ui-react";

export interface InputRestrictions {
  allowDigits: boolean
  allowLetters: boolean
  allowUnderscore: boolean
}

interface ISystemOneInputProps {
  required?: boolean
  restrict?: InputRestrictions
}

type State = typeof initialState;
const initialState = { error: false };

class SystemOneInput extends React.Component<ISystemOneInputProps & InputProps, State> {
  inputRef: React.RefObject<Input> = React.createRef<Input>();

  initialError = (props: InputProps) => {
    if (props.error) {
      return props.error;
    }
    return false;
  };

  /* eslint-disable react/no-deprecated */
  componentWillReceiveProps(nextProps: InputProps): void {
    if (nextProps.error) {
      this.setState({ error: nextProps.error });
    }
    // this.setState({ error: false });
  }

  readonly state = { ...initialState, error: this.initialError(this.props) };

  input: any;

  charAllowed = (char) => {
    if (!this.props.restrict) {
      return true;
    }

    if (this.props.restrict.allowDigits && (keypress.isDigit(char))) {
      return true;
    }

    if (this.props.restrict.allowLetters && (keypress.isAlpha(char))) {
      return true;
    }

    if (this.props.restrict.allowUnderscore && (keypress.isUnderscore(char))) {
      return true;
    }

    /// / Always enable tab, to not break standard logic in page
    // if (keypress.isTab(char)) {
    //    return true;
    // }

    return false;
  };

  onKeyPress = (event: React.SyntheticEvent) => {
    if (this.props.restrict) {
      const e = event as any;

      if (this.charAllowed(e.which)) {
        return true;
      }

      event.preventDefault();
      event.stopPropagation();

      return false;
    }
  };

  onChange = (event, data) => {
    if (this.props.required && (data.value.trim() === "" || !data.value)) {
      this.setState({ error: true });
    } else {
      this.setState({ error: false });
    }

    if (this.props.onChange) {
      this.props.onChange(event, data);
    }
  };

  focus() {
    this.inputRef.current.focus();
  }

  public render(): JSX.Element {
    const { value, ...rest } = this.props as InputProps;

    const propsToPass = {
      ...rest,
      error: this.state.error || this.props.error,
      onChange: this.onChange,
      onKeyPress: this.onKeyPress,
      value: value || ""
    };

    return (
      <Input
        ref={this.inputRef}
        {...propsToPass}
      >
        {this.props.children}
      </Input>
    );
  }
}

export default SystemOneInput;
